module.exports={
	"Form": "FundingSourceCreateManifest",
	"Scope": "FundingSource-Create",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-Create-Identity",
				"Group": "FundingSource-Create-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-Create-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-Create-Identity",
				"Group": "FundingSource-Create-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
